export const MEDIATAILOR_BASE_URL =
  'https://dbfc60fb257a4fa69b8410fae7d4d3b6.mediatailor.us-west-2.amazonaws.com';
const MEDIATAILOR_SESSION_URL = `${MEDIATAILOR_BASE_URL}/v1/session/7c8ce5ad5bcc5198ca301174a2ead89b25915ca4/Flosport27/index.m3u8`;
const MEDIATAILOR_TRIGGER_URL =
  'https://22xzlsy0w4.execute-api.us-west-2.amazonaws.com/prod/trigger-nonlinear';

export interface MediaTailorSession {
  manifestUrl: string;
  trackingUrl: string;
}

export const createMediaTailorSession =
  async (): Promise<MediaTailorSession> => {
    const response = await fetch(MEDIATAILOR_SESSION_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      throw new Error(`MediaTailor session failed with ${response.status}`);
    }

    const data = (await response.json()) as Partial<MediaTailorSession>;
    if (!data.manifestUrl || !data.trackingUrl) {
      throw new Error(
        'MediaTailor session is missing manifest or tracking URL',
      );
    }

    return {
      manifestUrl: MEDIATAILOR_BASE_URL + data.manifestUrl,
      trackingUrl: MEDIATAILOR_BASE_URL + data.trackingUrl,
    };
  };

export const triggerMediaTailorInjection = async (): Promise<void> => {
  await fetch(MEDIATAILOR_TRIGGER_URL);
};
